site.supportbox = {
	init: function() {
		$('section.support button').on('click', function() {
			$(this).toggleClass('show');
			$(this).siblings().toggleClass('show');
		});
	}
}
site.inits.push('site.supportbox.init()');
